import { CurrencyPipe } from "@angular/common";
import { Component } from '@angular/core';
import { ShareGroupView } from "@pages/shares/models/share-group-view";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

type CellRendererParams = ICellRendererParams<ShareGroupView> & {
  valueKey: keyof ShareGroupView;
  alertValueKey: keyof ShareGroupView;
  alertPrefix: string;
  applyCurrency: boolean | undefined;
  showAlert: boolean | undefined;
}

@Component({
  selector: 'app-ag-shares-number-with-alert',
  standalone: true,
  templateUrl: 'ag-shares-number-with-alert.component.html',
  imports: [
    CurrencyPipe
  ],
  styleUrl: 'ag-shares-number-with-alert.component.scss'
})
export class AgSharesNumberWithAlertComponent implements ICellRendererAngularComp {
  hasIssue = false;
  value: number | null = null;
  alertValue = 0;
  alertPrefix: string | null = null;
  applyCurrency = false;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    const shareGroupView = new ShareGroupView(params.data);
    const showAlert = params.showAlert ?? false;

    this.hasIssue = shareGroupView.hasIssue && showAlert;
    this.value = shareGroupView[params.valueKey] as number ?? null;
    this.alertValue = shareGroupView[params.alertValueKey] as number ?? 0;
    this.alertPrefix = params.alertPrefix ?? null;
    this.applyCurrency = params.applyCurrency ?? false;

    return true;
  }
}
